import { useQuery } from '@tanstack/react-query';
import { apiClient } from './client';

export type Confidence = 'high' | 'medium' | 'low';

export interface PowerIndexSummary {
  solar_index: number | null;
  wind_index: number | null;
  combined_index: number | null;
  corrected_combined_index: number | null;
  confidence: Confidence;
  confidence_label: string;
  price_signal: string;
  main_drivers: string[];
  risk_notes: string[];
  solar_correction_factor: number;
  solar_midday_std: number | null;
  wind_std: number | null;
}

export interface PowerIndexHour {
  h: number;
  solar_index: number | null;
  wind_index: number | null;
  combined_index: number | null;
  corrected_combined_index: number | null;
}

export interface PowerIndexTimeBlock {
  key: string;
  label: string;
  combined_index: number | null;
  corrected_combined_index: number | null;
  confidence: Confidence;
  note: string;
}

export interface PowerIndexPrefecture {
  name: string;
  prefecture: string;
  solar_capacity_mw: number;
  wind_capacity_mw: number;
  midday_solar_index: number | null;
  daily_combined_index: number | null;
  corrected_daily_combined_index: number | null;
  contribution_share: number;
  correction_factor: number;
  confidence: Confidence;
}

export interface WeatherPowerIndexResponse {
  date: string | null;
  model: string;
  data_type: string;
  summary: PowerIndexSummary | null;
  hours: PowerIndexHour[];
  time_blocks: PowerIndexTimeBlock[];
  prefectures: PowerIndexPrefecture[];
  data_freshness: 'ok' | 'empty';
  message: string | null;
}

export function useWeatherPowerIndex() {
  return useQuery({
    queryKey: ['weather', 'power-index'],
    queryFn: async () => {
      const res = await apiClient.get<WeatherPowerIndexResponse>('/weather/power-index');
      return res.data;
    },
    staleTime: 10 * 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

